function initSmallLayoutAnimations(){
    //Standard to top link animation
    $('.top-link').on('click',function () {
        $('body,html').animate({
            scrollTop: 0
        }, 800);
    });

    // open contact modal after submit and page reload
    if (location.hash !== '') {
        let pageHash = location.hash;
        let $modalWrapper = $(pageHash).parents('.modal');
        if ($modalWrapper.length > 0) {
            $modalWrapper.modal('show');
        }
    }

    let $heroScrollDown = $('.hero-image-wrapper > .rev-scroll-btn');
    if($heroScrollDown.length > 0) {
        $heroScrollDown.on('click', function (e) {
            let $heroImage = $(this).parents('.frame');
            let imageOffsetBottom = $heroImage.offset().top + $heroImage.height();
            let offsetTop = imageOffsetBottom - $('.main-navbar').height();

            $('html, body').animate({
                scrollTop: offsetTop
            }, 800);
        });
    }
}